import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  category: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getCategory.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getCategory.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      category: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getCategory.rejected, (state, action) => ({
      ...state,
      loading: false,
      category: [],
      totalCount: 0,
    }));

    // //add category
    builder.addCase(Act.addCategory.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.addCategory.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.addCategory.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // edit category
    builder.addCase(Act.editCategory.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editCategory.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.editCategory.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // delete category
    builder.addCase(Act.deleteCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.deleteCategory.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.deleteCategory.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default slice;
